/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import {
  HeadingDesc,
  SectionHeadingMed,
  SectionHeadingSmall
} from '../Headings';
import './contentWithIconBox.css';

function ContentWithIconBox(props) {
  const { heading, desc, iconBoxes } = props;
  return (
    <div className="contentWithIcon">
      <Container>
        <Row>
          <Col md={8} className="offset-lg-2">
            <SectionHeadingMed text={heading} />
            <HeadingDesc text={desc} />
          </Col>
          <Col md={12}>
            <div className="iconBoxContainer">
              {iconBoxes.map((iconBoxe, index) => {
                const { icon, countedUser, title } = iconBoxe;
                return (
                  <div className="iconBox" key={index}>
                    <div className="imgBox">
                      <img src={icon} alt="icon" />
                    </div>
                    <SectionHeadingSmall text={countedUser} />
                    <SectionHeadingSmall text={title} />
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ContentWithIconBox;
